import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewDeposito = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'deposito',
        name: 'Deposito',
        component: ViewDeposito,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
